<template>
    <div>
        <div class="md-modal modal-msg md-modal-transition" v-bind:class="{'md-show':mdShow}">
            <div class="md-modal-inner">
                <div>
                    <button class="md-close" @click="closeModal">×</button>
                </div>
                <div>
                    <div class="confirm-tips">
                        <slot name="message"></slot>
                    </div>
                    <div class="btn-wrap">
                        <slot name="btnGroup"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="md-overlay" v-if="mdShow" @click="closeModal"></div>
    </div>
</template>

<script>
    export default {
        name: "Model",
        props: ["mdShow"],
        data() {
            return {}
        },
        methods: {
            closeModal() {
                this.$emit("close");
            }
        }
    }
</script>
<style>

</style>